var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreVert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1319_2125",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1319_2125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 30.8975C19.5413 30.8975 19.149 30.7343 18.8226 30.408C18.4962 30.0816 18.333 29.6892 18.333 29.2309C18.333 28.7725 18.4962 28.3802 18.8226 28.0538C19.149 27.7274 19.5413 27.5642 19.9997 27.5642C20.458 27.5642 20.8504 27.7274 21.1768 28.0538C21.5031 28.3802 21.6663 28.7725 21.6663 29.2309C21.6663 29.6892 21.5031 30.0816 21.1768 30.408C20.8504 30.7343 20.458 30.8975 19.9997 30.8975ZM19.9997 21.6667C19.5413 21.6667 19.149 21.5035 18.8226 21.1771C18.4962 20.8507 18.333 20.4584 18.333 20C18.333 19.5417 18.4962 19.1493 18.8226 18.823C19.149 18.4966 19.5413 18.3334 19.9997 18.3334C20.458 18.3334 20.8504 18.4966 21.1768 18.823C21.5031 19.1493 21.6663 19.5417 21.6663 20C21.6663 20.4584 21.5031 20.8507 21.1768 21.1771C20.8504 21.5035 20.458 21.6667 19.9997 21.6667ZM19.9997 12.4359C19.5413 12.4359 19.149 12.2727 18.8226 11.9463C18.4962 11.6199 18.333 11.2275 18.333 10.7692C18.333 10.3109 18.4962 9.91851 18.8226 9.59212C19.149 9.26573 19.5413 9.10254 19.9997 9.10254C20.458 9.10254 20.8504 9.26573 21.1768 9.59212C21.5031 9.91851 21.6663 10.3109 21.6663 10.7692C21.6663 11.2275 21.5031 11.6199 21.1768 11.9463C20.8504 12.2727 20.458 12.4359 19.9997 12.4359Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVert);
export default __webpack_public_path__ + "static/media/more_vert.37074de451663ab4f9e93a4b6571c597.svg";
export { ForwardRef as ReactComponent };